export const LEGAL_VERSION = "1.0.0";
export const LEGAL_UPDATED_AT = "2025-10-31";
